import {Text} from '@dropbox/dig-components/typography';
import {atoms} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';
import {ChevronDownLine} from '@dropbox/dig-icons/assets';
import {Table} from 'components/DSYS/Table';
import {t} from 'i18next';
import type {Ref} from 'react';

import styles from './SubworkstreamSectionHeaderRow.module.css';

export const SubworkstreamSectionHeaderButton = ({
  dependencyCount,
  onCollapse,
}: {
  dependencyCount: number;
  onCollapse: () => void;
}) => (
  <button
    type="button"
    onClick={onCollapse}
    className={atoms({display: 'flex', alignItems: 'center'})}
    style={{gap: 8, cursor: 'pointer', background: 'none', border: 'none', padding: 0}}
  >
    <UIIcon src={ChevronDownLine} className={atoms({color: 'Text Subtle'})} size="small" />
    <Text size="small" isBold>
      {t('sub_workstream_count', {count: dependencyCount})}
    </Text>
  </button>
);

export const SubworkstreamSectionHeaderRow = ({
  colSpan,
  dependencyCount,
  onCollapse,
  headerSentinelRef,
}: {
  colSpan: number;
  dependencyCount: number;
  onCollapse: () => void;
  headerSentinelRef?: Ref<HTMLDivElement>;
}) => {
  const headerContent = (
    <SubworkstreamSectionHeaderButton dependencyCount={dependencyCount} onCollapse={onCollapse} />
  );

  return (
    <Table.Row className={styles.sectionHeader} data-subworkstream-section-header="true">
      <Table.Cell colSpan={colSpan} className={styles.sectionHeaderCell}>
        {headerSentinelRef ? (
          <div ref={headerSentinelRef} style={{position: 'absolute', top: 0, left: 0, right: 0}} />
        ) : null}
        {headerContent}
      </Table.Cell>
    </Table.Row>
  );
};
